<template>
  <div class="base-control base-select form-group" :class="{row: inline, 'error': hasErrors, 'ok': isOk, disabled: disabled}">
    <label :for="id" :class="{'col-form-label': inline, [col1]: true}">{{ label }}</label>
    <div :class="{'position-relative': inline, [col2]: true}">
      <v-select
          ref="input"
          :id="id"
          :value="value"
          :class="{[radius]: true, 'is-invalid': hasErrors, 'form-control': true}"
          @input="changed($event)"
          :options="options"
          :placeholder="placeholder"
          :searchable="searchable"
          :label="selectLabel"
          :disabled="disabled"
          :secondary-label="secondaryLabel"
          :clearable="false"
      >
        <template slot="selected-option" slot-scope="option">
          {{ secondaryLabel ? (option[selectLabel].length ? option[selectLabel] : option[secondaryLabel]) : (option[selectLabel]) }}
        </template>
        <template slot="option" slot-scope="option">
          <span>{{ secondaryLabel ? (option[selectLabel].length ? option[selectLabel] : option[secondaryLabel]) : (option[selectLabel]) }}</span>
        </template>
      </v-select>
      <div class="invalid-feedback" :class="{'absolute-right-errors': (hasErrors && inline && !$slots['right-container'] && !errorsNextLine)}" v-if="err && err.length > 0">
        <p class="error mb-0" v-for="error in err" :key="error">{{ error }}</p>
      </div>
      <div class="right-container">
        <slot name="right-container"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select';

  export default {
    name: 'BaseSelect',
    inject: ['$validator'],
    props: {
      value: {},
      disabled: {
        type: Boolean,
        default: false
      },
      col1: {
        type: String,
        default: 'col-sm-4'
      },
      col2: {
        type: String,
        default: 'col-sm-8'
      },
      selectLabel: {
        type: String,
        default: 'label'
      },
      secondaryLabel: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      radius: {
        type: String,
        default: ''
      },
      err: {
        type: Array,
        default: () => []
      },
      inline: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: 'Please select'
      },
      searchable: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default: () => []
      },
      errorsNextLine: {
        type: Boolean,
        default: false
      },
      valueBy: {
        type: String,
        default: ''
      }
    },
    $_veeValidate: {
      value () {
        return this.$refs.input.value;
      },
      name () {
        return this.name;
      }
    },
    mounted () {

    },
    watch: {
      options (newValue) {
        if (!newValue.length) {
          this.$emit('input', null);
        }
      }
    },
    computed: {
      id () {
        return 'base-select-' + this._uid;
      },
      hasErrors () {
        return this.err && this.err.length > 0;
      },
      isOk() {
        let k = '';
        for (const key in this.fields) {
          k = key;
        }
        if (!this.fields[k] || !this.fields[k][this.name]) return false;
        return this.fields[k][this.name].validated && this.fields[k][this.name].valid;
      },
    },
    methods: {
      changed(event) {
        if (this.valueBy !== '') {
          this.$emit('input', event[this.valueBy]);
        } else {
          this.$emit('input', event);
        }
      }
    },
    components: {
      vSelect
    }
  };

</script>

<style>
  .vs__selected-options{
    max-height: 35px;
    height: 100%;
    overflow: auto;
  }

</style>
